export const funnelSchema = [
  { name: "Conversion_funnel", label: "Conversion funnel", sort: false },
  { name: "percentage2", label: "%" },
  { name: "change", label: "% Change" },
  { name: "count", label: "Count" },
];
